import { render } from "./B2bFiltersTaxes.vue?vue&type=template&id=96e0eb5e&scoped=true&lang=pug"
import script from "./B2bFiltersTaxes.vue?vue&type=script&lang=js"
export * from "./B2bFiltersTaxes.vue?vue&type=script&lang=js"

import "./B2bFiltersTaxes.vue?vue&type=style&index=0&id=96e0eb5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e0eb5e"]])

export default __exports__